import { render, staticRenderFns } from "./LogView.vue?vue&type=template&id=5fd65dd8&scoped=true"
import script from "./LogView.vue?vue&type=script&lang=ts"
export * from "./LogView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd65dd8",
  null
  
)

export default component.exports